import { Link } from "react-router-dom";
import { Lock } from "lucide-react";

export const Footer = () => {
  return (
    <footer data-testid="footer" className="bg-sage-900 text-sage-100 py-12">
      <div className="container mx-auto px-6 md:px-12 text-center">
        <div className="font-script text-4xl text-sage-200 mb-2">Nico &amp; Nicole</div>
        <div className="text-xs uppercase tracking-[0.3em] text-sage-300/80 mb-6">
          01. August 2026 · Gut Haferkorn
        </div>
        <div className="flex items-center justify-center gap-3 mb-6">
          <span className="h-px w-12 bg-sage-600" />
          <span className="font-script text-sage-300 text-xl">für immer</span>
          <span className="h-px w-12 bg-sage-600" />
        </div>

        <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-3 mb-6 text-xs uppercase tracking-[0.2em] text-sage-300">
          <Link to="/impressum" className="hover:text-sage-100" data-testid="footer-impressum">
            Impressum
          </Link>
          <span className="text-sage-700">·</span>
          <Link to="/datenschutz" className="hover:text-sage-100" data-testid="footer-datenschutz">
            Datenschutz
          </Link>
          <span className="text-sage-700">·</span>
          <Link to="/agb" className="hover:text-sage-100" data-testid="footer-agb">
            AGB
          </Link>
        </div>

        <div className="flex items-center justify-center gap-4 mb-6">
          <Link
            data-testid="footer-admin-login"
            to="/admin"
            className="inline-flex items-center gap-2 rounded-full border border-sage-700 text-sage-300 hover:bg-sage-800 hover:text-sage-100 px-5 py-2 text-xs uppercase tracking-[0.25em] transition-colors"
          >
            <Lock size={12} />
            Admin-Login
          </Link>
        </div>
        <p className="text-sage-300/70 text-xs">Mit Liebe gemacht · © 2026 Nico Haage</p>
      </div>
    </footer>
  );
};

export default Footer;
